export default __webpack_public_path__ + "static/media/backward.c831a6bd.svg";